"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDK_FUNCTIONALITY = exports.MODULE_NAME = exports.DATA_MODULE_SDK_FEATURES = exports.SDK_FUNCTIONALITY_DATA = exports.SDK_FUNCTIONALITY_USER = exports.SDK_FUNCTIONALITY_ADS = exports.sdkFeatureRequirementsText = exports.JS_SDK_URLS = exports.LATEST_SDK_URL = void 0;
exports.LATEST_SDK_URL = 'https://sdk.crazygames.com/crazygames-sdk-v3.js';
exports.JS_SDK_URLS = [
    'https://sdk.crazygames.com/crazygames-sdk-v1.js',
    'https://sdk.crazygames.com/crazygames-sdk-v2.js',
    exports.LATEST_SDK_URL,
];
exports.sdkFeatureRequirementsText = {
    happytime: 'Happy time',
    gameplayStart: 'Gameplay start',
    gameplayStop: 'Gameplay stop',
    sdkGameLoadingStart: 'SDK game loading start',
    sdkGameLoadingStop: 'SDK game loading stop',
    rewardedAd: 'Rewarded ad',
    midgameAd: 'Midgame ad',
    inviteLink: 'Invite link',
    banner: 'Banner',
    sdkInit: 'SDK Initialization',
    showInviteButton: 'Show Invite Button',
    hideInviteButton: 'Hide Invite Button',
    useUserModule: 'Use user module',
    requestUserToken: 'Request user token',
    requestXsollaUserToken: 'Request Xsolla token',
    useDataModule: 'Use data module',
};
exports.SDK_FUNCTIONALITY_ADS = [
    'requestMidgameAd',
    'requestRewardedAd',
    'requestBanner',
    'requestResponsiveBanner',
    'clearBanner',
    'clearAllBanners',
];
exports.SDK_FUNCTIONALITY_USER = [
    'showAuthPrompt',
    'showAccountLinkPrompt',
    'getUser',
    'getUserToken',
    'getXsollaUserToken',
    'authListener',
];
exports.SDK_FUNCTIONALITY_DATA = ['clear', 'getItem', 'removeItem', 'setItem'];
exports.DATA_MODULE_SDK_FEATURES = ['clear', 'getItem', 'removeItem', 'setItem'];
exports.MODULE_NAME = {
    ad: 'Ad',
    banner: 'Banner',
    game: 'Game',
    user: 'User',
    data: 'Data',
    analytics: 'Analytics',
};
exports.SDK_FUNCTIONALITY = [
    // ==================== Ad module ====================
    {
        module: 'ad',
        name: 'requestMidgameAd',
        displayName: 'Request Midgame Ad',
        triggeredBy: ['midgameAd'],
    },
    {
        module: 'ad',
        name: 'requestRewardedAd',
        displayName: 'Request Rewarded Ad',
        triggeredBy: ['rewardedAd'],
    },
    // ==================== Banner module ====================
    {
        module: 'banner',
        name: 'requestBanner',
        displayName: 'Request Banner',
        triggeredBy: ['banner'],
    },
    {
        module: 'banner',
        name: 'requestResponsiveBanner',
        displayName: 'Request Responsive Banner',
        triggeredBy: ['responsiveBanner'],
    },
    {
        module: 'banner',
        name: 'clearBanner',
        displayName: 'Clear Banner',
        triggeredBy: ['clearBanner'],
    },
    {
        module: 'banner',
        name: 'clearAllBanners',
        displayName: 'Clear All Banners',
        triggeredBy: ['clearAllBanners'],
    },
    // ==================== Game module ====================
    {
        module: 'game',
        name: 'happytime',
        displayName: 'Happytime',
        triggeredBy: ['happytime'],
    },
    {
        module: 'game',
        name: 'gameplayStart',
        displayName: 'Gameplay Start',
        triggeredBy: ['gameplayStart'],
    },
    {
        module: 'game',
        name: 'gameplayStop',
        displayName: 'Gameplay Stop',
        triggeredBy: ['gameplayStop'],
    },
    {
        module: 'game',
        name: 'loadingStart',
        displayName: 'Loading Start',
        triggeredBy: ['sdkGameLoadingStart'],
    },
    {
        module: 'game',
        name: 'loadingStop',
        displayName: 'Loading Stop',
        triggeredBy: ['sdkGameLoadingStop'],
    },
    {
        module: 'game',
        name: 'inviteLink',
        displayName: 'Invite Link',
        triggeredBy: ['inviteLink'],
    },
    {
        module: 'game',
        name: 'showInviteButton',
        displayName: 'Show Invite Button',
        triggeredBy: ['showInviteButton'],
    },
    {
        module: 'game',
        name: 'hideInviteButton',
        displayName: 'Hide Invite Button',
        triggeredBy: ['hideInviteButton'],
    },
    // ==================== User module ====================
    {
        module: 'user',
        name: 'showAuthPrompt',
        displayName: 'Show Auth Prompt',
        triggeredBy: ['showAuthPrompt'],
    },
    {
        module: 'user',
        name: 'showAccountLinkPrompt',
        displayName: 'Show Account Link Prompt',
        triggeredBy: ['showAccountLinkPrompt'],
    },
    {
        module: 'user',
        name: 'getUser',
        displayName: 'Get User',
        triggeredBy: ['getUser'],
    },
    {
        module: 'user',
        name: 'getUserToken',
        displayName: 'Get User Token',
        triggeredBy: ['requestUserToken'],
    },
    {
        module: 'user',
        name: 'getXsollaUserToken',
        displayName: 'Get Xsolla User Token',
        triggeredBy: ['requestXsollaUserToken'],
    },
    {
        module: 'user',
        name: 'authListener',
        displayName: 'Auth Listener',
        triggeredBy: ['addAuthListener'],
    },
    // ==================== Analytics module ====================
    {
        module: 'analytics',
        name: 'trackOrder',
        displayName: 'Track Order',
        triggeredBy: ['analyticsTrackIAPOrder'],
    },
    // ==================== Data module ====================
    // detection for data module is based on the "useDataModule" GF event, and the "action" field from this event
    {
        module: 'data',
        name: 'clear',
        displayName: 'Clear',
    },
    {
        module: 'data',
        name: 'getItem',
        displayName: 'Get Item',
    },
    {
        module: 'data',
        name: 'removeItem',
        displayName: 'Remove Item',
    },
    {
        module: 'data',
        name: 'setItem',
        displayName: 'Set Item',
    },
];
